module.exports = __webpack_public_path__ + "img/undraw_winners.88a19945.svg";